import angular from "angular";

import AdminOrganisationsModuleRouting from "./admin-organisations.module.routing";

export default angular
  .module("vt-admin-organisations", [])
  .config(AdminOrganisationsModuleRouting);
